module.exports = __webpack_public_path__ + "Simple-Line-Icons.f33df365d6d0255b586f.eot";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/simple-line-icons/Simple-Line-Icons.eot?v=2.4.0
// module id = ../../../../../src/assets/fonts/simple-line-icons/Simple-Line-Icons.eot?v=2.4.0
// module chunks = 40